module.exports = __webpack_public_path__ + "img/pse.a3352a84.svg";